// Static alias map: normalised common names -> correct Wikipedia article titles.
// Keys are lowercase, spaces only, no punctuation. Values are the Wikipedia
// article title (usually the scientific/Latin name) that has a thumbnail image.
// Used by fetchWikiImage() Phase 3 when the plant's wiki field doesn't match
// any Wikipedia article directly.
export const WIKI_ALIASES = {
  // Houseplants with common-name-only recognition
  "zanzibar gem":          "Zamioculcas",
  "zz plant":              "Zamioculcas",
  "swiss cheese plant":    "Monstera deliciosa",
  "monstera":              "Monstera deliciosa",
  "mother in laws tongue": "Dracaena trifasciata",
  "snake plant":           "Dracaena trifasciata",
  "bird of paradise":      "Strelitzia reginae",
  "peace lily":            "Spathiphyllum wallisii",
  "rubber plant":          "Ficus elastica",
  "fiddle leaf fig":       "Ficus lyrata",
  "spider plant":          "Chlorophytum comosum",
  "pothos":                "Epipremnum aureum",
  "devils ivy":            "Epipremnum aureum",
  "aloe vera":             "Aloe vera",
  "jade plant":            "Crassula ovata",
  "money tree":            "Pachira aquatica",
  "string of pearls":      "Curio rowleyanus",
  "cast iron plant":       "Aspidistra elatior",
  "boston fern":            "Nephrolepis exaltata",
  "maidenhair fern":       "Adiantum",
  "chinese money plant":   "Pilea peperomioides",
  "weeping fig":           "Ficus benjamina",
  "parlour palm":          "Chamaedorea elegans",
  "parlor palm":           "Chamaedorea elegans",
  "prayer plant":          "Maranta leuconeura",
  "calathea":              "Goeppertia",
  "dumb cane":             "Dieffenbachia",
  "umbrella plant":        "Schefflera",
  "christmas cactus":      "Schlumbergera",
  "easter cactus":         "Hatiora gaertneri",
  // Garden plants with common-name issues
  "bleeding heart":        "Lamprocapnos spectabilis",
  "black eyed susan":      "Rudbeckia hirta",
  "coneflower":            "Echinacea",
  "bee balm":              "Monarda",
  "coral bells":           "Heuchera",
  "daylily":               "Hemerocallis",
  "day lily":              "Hemerocallis",
  "hosta":                 "Hosta (plant)",
  "creeping jenny":        "Lysimachia nummularia",
  "lambs ear":             "Stachys byzantina",
  "russian sage":          "Salvia yangii",
  // UK garden favourites
  "foxglove":              "Digitalis purpurea",
  "snowdrop":              "Galanthus",
  "bluebell":              "Hyacinthoides non-scripta",
  "primrose":              "Primula vulgaris",
  "forget me not":         "Myosotis",
  "sweet william":         "Dianthus barbatus",
  "hollyhock":             "Alcea rosea",
  "love in a mist":        "Nigella damascena",
  "red hot poker":         "Kniphofia",
  "lords and ladies":      "Arum maculatum",
  "granny bonnet":         "Aquilegia vulgaris",
  "columbine":             "Aquilegia",
  "lungwort":              "Pulmonaria",
  "elephant ears":         "Bergenia",
  "catmint":               "Nepeta",
};
